module.exports = __webpack_public_path__ + "img/instagram_card.84ef213b.png";